function UserContactConfirm(){
  'use strict';
  this.__type = 'UserContactConfirm:www.veritracks.com';
  this.UserContactMethodId = -1;
  this.UserContactValue = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = UserContactConfirm;
}